import json from "@/data/database.json";
import type { Question } from "@/data/types";

function mapQuestions<T extends Record<string, any[]>>(
  obj: T,
): Record<string, Question[]> {
  const result: Record<string, Question[]> = {};
  for (const key in obj) {
    if (obj[key]) {
      result[key] = obj[key].map((q) => ({
        q: q.q,
        opts: q.opt,
      }));
    }
  }
  return result;
}

export const useQuestions = () => {
  const data = mapQuestions(json.data);

  return { data };
};
